const dedupeArray = <T = unknown>(array: T[]): T[] => {
  const serializedItems = array.map((item) => JSON.stringify(item));
  const itemsSet = new Set(serializedItems);
  return Array.from(itemsSet).map((item) => JSON.parse(item));
};

export default dedupeArray;
